module.exports = __webpack_public_path__ + "d664201f/img/boston-lights.a623432f.png";